import { HTMLAttributes } from 'react';
import { TextWithIcon } from 'app/agriculture/components/TextWithIcon/TextWithIcon';
import { LinkIcon } from 'app/agriculture/icons';
import { primaryColourMain } from 'app/agriculture/material';

export function TankLinkAutocompleteOption({
    name,
    optionProps,
    isDisabled = false,
}: {
    name: string;
    isDisabled?: boolean;
    optionProps: HTMLAttributes<HTMLLIElement>;
}) {
    return (
        <li {...optionProps}>
            <TextWithIcon
                Icon={(iconProps) => (
                    <LinkIcon {...iconProps} color={isDisabled ? '#eee' : primaryColourMain} />
                )}
            >
                {name}
            </TextWithIcon>
        </li>
    );
}
